import ExternalValuesSourceMeta from './ExternalValuesSourceMeta'

export default class ExternalValuesSourceGroupMeta {
    type
    id
    name
    /** @type {Array<ExternalValuesSourceMeta>} */
    source_metas

    constructor(group_meta) {
        this.type = group_meta.type
        this.id = group_meta.id
        this.name = group_meta.name
        this.source_metas = group_meta.source_metas.map(m => new ExternalValuesSourceMeta(m))
    }
}